import clsx from 'clsx'
import React, { useId } from 'react'

import { ROW_BG_CLASSES, ROW_BORDER_CLASSES, ROW_FOCUS_CLASSES } from './constants'
import { StickyCellBorder } from './StickyCellBorder'

interface TableRowHeaderProps extends Omit<React.ThHTMLAttributes<HTMLTableCellElement>, 'className'> {
  children: React.ReactNode;
  sticky?: boolean;
}

export function TableRowHeader ({
  children,
  sticky,
  ...props
}: TableRowHeaderProps) {
  const id = useId()

  return (
    <th
      {...props}
      aria-labelledby={id}
      className={clsx(
        'body text-left font-normal text-gray-800 transition py-2 pr-[var(--cell-spacing)] first:pl-[var(--cell-spacing)]',
        ROW_FOCUS_CLASSES,
        ROW_BG_CLASSES,
        ROW_BORDER_CLASSES,
        {
          sticky,
          'z-10': sticky,
        }
      )}
      data-sticky={sticky}
      scope='row'
    >
      <div className='flex items-center' id={id}>
        {children}
      </div>
      <StickyCellBorder sticky={sticky} />
    </th>
  )
}

TableRowHeader.displayName = 'Table.RowHeader'
